import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IPagination, IPaginationParams } from "@/types/pagination";

export interface IExamConfigDomain {
  id: string;
  name: string;
  order: number;
}

export interface IExamConfigSubject {
  subject: string;
  duration_default: number;
  question_count_default: number;
  calculator_allowed: boolean;
  passage_type: string;
  domains: IExamConfigDomain[];
}

export interface IExamConfig {
  id: string;
  subjects: IExamConfigSubject[];
  created_at: string;
  updated_at: string;
}

export interface IExamConfigListParams extends IPaginationParams {
  // Additional filters can be added here in the future
}

/**
 * 시험 설정 목록을 조회하는 API 함수
 * @param params 쿼리 파라미터 (페이징)
 * @returns API 응답 객체
 */
export const apiGetExamConfigList = async (params?: IExamConfigListParams) => {
  const response = await apiGet<IPagination<IExamConfig>>(
    "/exam_configs",
    params
  );
  return response.data;
};

/**
 * 시험 설정 목록을 React Query를 통해 조회하는 훅
 * @param params 쿼리 파라미터 (페이징)
 * @param options React Query 옵션
 * @returns 쿼리 결과
 */
export const useQueryGetExamConfigList = (
  params?: IExamConfigListParams,
  options = {}
) => {
  const queryKey = ["examConfigs", params];

  return useQuery({
    queryKey,
    queryFn: async () => {
      return await apiGetExamConfigList(params);
    },
    ...options,
  });
};

export default useQueryGetExamConfigList;
